import { render } from "./UserNotificationsForm.vue?vue&type=template&id=5e6205d9&scoped=true"
import script from "./UserNotificationsForm.vue?vue&type=script&lang=js"
export * from "./UserNotificationsForm.vue?vue&type=script&lang=js"

import "./UserNotificationsForm.vue?vue&type=style&index=0&id=5e6205d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6205d9"]])

export default __exports__